import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { apiExpedienteElectronico } from "services/expedienteElectronico/expedienteElectronico";
import { apiLibroIndice } from "services/indiceServices/indicesServices";
import { rootReducer } from "./rootReducer";
import { apiSolicitudFirma } from "services/solicitudFirmaService/solicitudFirmaService";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiExpedienteElectronico.middleware,
      apiLibroIndice.middleware,
      apiSolicitudFirma.middleware,
    ),
    devTools:process.env.REACT_APP_SITE === "production" ? false : true
});


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
